import { technologies } from "../data/mock";

const Technologies = () => {
  const groupedTech = technologies.reduce((acc, tech) => {
    if (!acc[tech.category]) {
      acc[tech.category] = [];
    }
    acc[tech.category].push(tech.name);
    return acc;
  }, {});

  const categoryColors = {
    Cloud: "from-blue-500 to-blue-600",
    "Contact Center": "from-purple-500 to-purple-600",
    Telephony: "from-indigo-500 to-indigo-600",
    Frontend: "from-cyan-500 to-cyan-600",
    Backend: "from-green-500 to-green-600",
    Mobile: "from-orange-500 to-orange-600",
    "AI/ML": "from-pink-500 to-pink-600",
    DevOps: "from-red-500 to-red-600",
    Database: "from-yellow-500 to-yellow-600",
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Technologies We Master
            </h1>
            <p className="text-blue-100 text-lg md:text-xl max-w-3xl mx-auto">
              Leveraging cutting-edge technologies to build robust, scalable, and innovative solutions
            </p>
          </div>
        </div>
      </section>

      {/* Tech Stack Categories */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Object.entries(groupedTech).map(([category, techs]) => (
              <div
                key={category}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
              >
                <div
                  className={`h-2 bg-gradient-to-r ${
                    categoryColors[category] || "from-gray-500 to-gray-600"
                  }`}
                />
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {category}
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {techs.map((tech, idx) => (
                      <span
                        key={idx}
                        className="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Philosophy */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🚀</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Modern & Scalable
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We use the latest technologies that ensure your solutions can grow with your business needs
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🔒</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Secure & Reliable
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Security is paramount in every technology choice we make for enterprise-grade reliability
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">⚡</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                High Performance
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Optimized tech stacks that deliver exceptional speed and efficiency for your applications
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Certified Expertise
          </h2>
          <p className="text-gray-600 text-lg mb-12">
            Our team holds industry-recognized certifications ensuring the highest standards of technical excellence
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {["AWS Certified", "Azure Certified", "Google Cloud", "Kubernetes"].map(
              (cert, idx) => (
                <div
                  key={idx}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-2xl">✓</span>
                  </div>
                  <p className="text-gray-900 font-semibold">{cert}</p>
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Technologies;
